import { Component, Input,ChangeDetectorRef, OnInit, ViewChild, ComponentFactoryResolver, OnDestroy } from '@angular/core';


import { PreloaderService } from '../../services/preloader.service';

@Component({
  selector: 'loader',
  templateUrl: './preloader.component.html',
  styleUrls: ['./preloader.component.scss']
})
export class PreloaderComponent implements OnInit, OnDestroy  {

  @Component({
    selector: 'app-ad-banner',
    template: './preloader.component.html',
    styleUrls: ['./preloader.component.css']
  })

    currentAdIndex = -1;
    interval: any;
  
    constructor(private componentFactoryResolver: ComponentFactoryResolver) { }
  
    ngOnInit() {
      this.getAds();
    }
  
    ngOnDestroy() {
      clearInterval(this.interval);
    }
  
  
  
    getAds() {
      this.interval = setInterval(() => {
        console.log('attendre 3 seconde');
      }, 3000);
    }
  }
  
  
  /*
  Copyright Google LLC. All Rights Reserved.
  Use of this source code is governed by an MIT-style license that
  can be found in the LICENSE file at https://angular.io/license
  */

